
import Vue from 'vue'
import Button from "@/components/button.vue";

export default Vue.extend({
  name: 'pd-deliveryblock',
  components: {
    "pd-button": Button
  },
  methods: {
    add() {
      this.clickFn(this.addressId)
    },
    adjustTextareaHeight() {
      const textareaRefs: any = [this.$refs["firsttext"], this.$refs["secondtext"]];
      for (let textareas of textareaRefs) {
        if (textareas) {
          for (let textarea of textareas) {

            textarea.style.height = "";
            textarea.style.height = textarea.scrollHeight + "px";
          }
        }
      }
    }
  },
  mounted(): void {
    setTimeout(() => {
          this.$nextTick(() => {
            this.adjustTextareaHeight();
          });
        }
        , 500);
  },
  data: () => ({}),
  props: {
    clickFn: Function,
    label: String,
    address: Object,
    addressId: String
  }
})
